import React, { useEffect, useContext, useState } from 'react'
import Bugsnag from '@bugsnag/js'
import { ModalProvider } from 'react-modal-hook'
import { config } from '../config'

import BugsnagPluginReact from '@bugsnag/plugin-react'
// import LogRocket from 'logrocket'

import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloProvider,
} from '@apollo/client'

import fetch from 'isomorphic-fetch'
import { Window } from '../utils'

import { getParamByISO } from 'iso-country-currency'
import { Global, css } from '@emotion/core'
import detectGoogle from '../utils/detectGoogle'

export const CountryContext = React.createContext({
  country: '',
  currency: '',
  loading: true,
})

export const isProduction =
  config.STAGE === 'production' || config.STAGE === 'staging'

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: config.GATSBY_STOREFRONT_URL,
    fetch,
    headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': config.GATSBY_SHOPIFY_ACCESS_TOKEN,
    },
  }),
})

// if (isProduction) {
//   LogRocket.init(config.LOG_ROCKET_KEY)
// }

Bugsnag.start({
  apiKey: config.GATSBY_BUGSNAG_KEY,
  enabledReleaseStages: ['production', 'staging', 'development'],
  releaseStage: config.STAGE,
  onError: error => {
    // error.addMetadata('logrocket', { url: LogRocket.sessionURL })
  },
  plugins: [new BugsnagPluginReact(React)],
})

const ErrorBoundary = Bugsnag.getPlugin('react')

export const wrapRootElement = ({ element }) => {
  return <App element={element}></App>
}

export const hideOsano = css`
  .osano-cm-dialog {
    display: none;
  }
  .osano-cm-window {
    display: none;
  }
`

export const showOsano = css`
  .osano-cm-dialog {
    display: none;
  }
`

const App = ({ element }) => {
  const [geoState, setGeoState] = useState({})
  const [showOsano, setShowOsano] = useState(false)

  const fetchRequestCountry = async () => {
    const isGoogle = detectGoogle()
    if (isGoogle) {
      setGeoState({
        country: 'US',
        currency: 'USD',
        loading: false,
      })
      return
    }

    fetch('https://get.geojs.io/v1/ip.json').then(ip => {
      ip.json().then(data =>
        fetch(`https://get.geojs.io/v1/ip/country/${data.ip}.json`)
          .then(country =>
            country
              .json()
              .then(data => {
                const currency =
                  data.country && getParamByISO(data.country, 'currency')
                if (data.country !== 'US') {
                  setShowOsano(true)
                  Window && window.Osano && window.Osano.cm.showDialog()
                }

                const isIndia = data.country === 'IN'

                setGeoState({
                  country: isIndia ? 'US' : data.country || 'US',
                  currency: isIndia ? 'USD' : currency || 'USD',
                  loading: false,
                })
              })
              .catch(e => {
                setGeoState({
                  country: 'US',
                  currency: 'USD',
                  loading: false,
                })
              })
          )
          .catch(e => {
            setGeoState({
              country: 'US',
              currency: 'USD',
              loading: false,
            })
          })
      )
    })
  }

  useEffect(() => {
    fetchRequestCountry()
  }, [])

  return (
    <ErrorBoundary>
      <>
        {showOsano ? (
          <Global styles={showOsano} />
        ) : (
          <Global styles={hideOsano} />
        )}
      </>
      <CountryContext.Provider value={geoState}>
        <ModalProvider>
          <ApolloProvider client={client}>{element}</ApolloProvider>
        </ModalProvider>
      </CountryContext.Provider>
    </ErrorBoundary>
  )
}
